import React, { useRef } from 'react';
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.
import logoSrc from '../img/logo.png'; // Assuming logo.png is in the img folder


function Business() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
   
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" id="titulli">numbers that guide decisions</h1>
            <p className="banner-description">
              Gain unparalleled insights and data-driven solutions with Shigjeta's business statistics services. 
              We analyze markets, trends, and strategies to empower businesses for smarter decisions.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
  
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Premium Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      {/* About Section */}
      <section className="about-section">
        {/* Market Research Solutions */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Comprehensive Market Research</strong></h2>
            <p>
              Unlock deep market understanding through customized research solutions. Our team collects and interprets 
              key metrics to fuel your strategic decisions.
            </p>
            <ul>
              <li><strong>Target Audience Analysis:</strong> Identify and understand key demographics.</li>
              <li><strong>Trend Forecasting:</strong> Stay ahead with reliable market predictions.</li>
              <li><strong>Competitor Benchmarking:</strong> Analyze strengths and opportunities.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps1.1.png" alt="Market Research Solutions" />
          </div>
        </div>

        {/* Customized Business Statistics */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Data-Driven Business Solutions</strong></h2>
            <p>
              Tailored business statistics help organizations drive performance and achieve measurable results. 
              Shigjeta’s experts provide actionable data insights aligned with your goals.
            </p>
            <ul>
              <li><strong>Performance Metrics:</strong> Measure progress effectively.</li>
              <li><strong>Operational Efficiency:</strong> Streamline workflows with data.</li>
              <li><strong>Custom Reports:</strong> Insights tailored to your needs.</li>
            </ul>
        
          </div>
          <div className="about-image">
            <img src="/img/ps1.2.png" alt="Customized Business Statistics" />
          </div>
        </div>

        {/* Economic Analysis */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Economic Trends & Analysis</strong></h2>
            <p>
              Stay informed with Shigjeta’s economic analysis services. We provide critical insights on economic 
              patterns and industry performance to guide decision-making.
            </p>
            <ul>
              <li><strong>Economic Reports:</strong> In-depth economic data and insights.</li>
              <li><strong>Industry Trends:</strong> Identify emerging opportunities.</li>
              <li><strong>Strategic Planning:</strong> Build stronger growth strategies.</li>
            </ul>
            
          </div>
          <div className="about-image">
            <img src="/img/ps1.3.png" alt="Economic Trends & Analysis" />
          </div>
        </div>

        {/* Success Through Insights */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Driving Success with Insights</strong></h2>
            <p>
              Transform data into opportunity. Shigjeta’s business market statistics empower companies to 
              innovate, scale, and achieve success through evidence-based strategies.
            </p>
            <ul>
              <li><strong>Strategic Insights:</strong> Actionable plans backed by data.</li>
              <li><strong>Risk Reduction:</strong> Mitigate uncertainty with research.</li>
              <li><strong>Business Growth:</strong> Drive sustainable success.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps1.4.png" alt="Success Through Insights" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default Business;
